var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"field-content"},[_c('p',[_vm._v("Identifies volatility squeeze setups with structural compression. GMMA alignment plus low BBW or RVM signals coiled price action. Watch for potential expansion or breakout.")])])])
}]

export { render, staticRenderFns }